import { Observable } from 'rxjs'
import AxiosSubscriber from '../../factory/AxiosSubscriber'
import {
  requestAccessToken,
  requestTokenSourceType,
  requestTokenSourceByLogin,
} from '../../shared/requestAccessToken'

/**
 * Saves every annotation the reviewer staged in the viewer in one request, so a
 * review session produces a single timeline entry and a single notification no
 * matter how many shapes it contains.
 *
 * AxiosSubscriber picks the /d or /c prefix from the stored clientId, so the same
 * class serves internal users and customers.
 */
export class BulkAddAnnotationsAPI {
  constructor() {
    this.subscription = null
  }

  /**
   * @param annotations array of {message, annotation}, both already serialised -
   *        message is draftjs raw content, annotation is the shape payload.
   */
  subscribe(
    orderId,
    attachmentId,
    versionId,
    annotations,
    type,
    next,
    complete,
    error
  ) {
    const token = localStorage.getItem('token')

    const sourceType = requestTokenSourceByLogin(
      requestTokenSourceType.CARD_ANNOTATION
    )
    requestAccessToken(sourceType, (csrfToken) => {
      const httpConfig = {
        url: `/order/${orderId}/attachment/${attachmentId}/version/${versionId}/annotation/bulk`,
        method: 'post',
        data: {
          annotations: JSON.stringify(annotations),
          type: type,
        },
        headers: {
          'x-csrf': csrfToken,
          accept: 'application/json',
          'Content-Type': `application/json`,
          Authorization: `Bearer ${token}`,
        },
      }

      let observable$ = new Observable((observer) => {
        return new AxiosSubscriber(observer, httpConfig)
      })

      this.subscription = observable$.subscribe({
        next: next,
        complete: complete,
        error: error,
      })
    })
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe()
    }
  }
}
